var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLecture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M233.5,192.1V31.1C121.1,42.4,31.1,138.8,31.1,256s89.9,213.6,202.4,224.9v-161c-22.5-9.2-45-34.2-45-63.9s22.5-54.6,45-63.9ZM320.3,233.5h160.6c-10.8-106.8-89.9-191.8-202.4-202.4v161c22.5,6.7,34.2,22,41.8,41.4ZM278.5,319.9v161c112.4-10.6,191.6-95.6,202.4-202.4h-160.6c-7.6,19.3-19.3,34.6-41.8,41.4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLecture);
export default __webpack_public_path__ + "static/media/lecture.d7805365fa8bf8292eca2f032adaff4b.svg";
export { ForwardRef as ReactComponent };